<div class="dropdown">
  <button (click)="onToggle()" class="btn btn-outline-success btn-round" type="button">
    Filter <i class="fa fa-filter"></i>
  </button>
  <form #filterForm="ngForm" (ngSubmit)="onFilter()">
    <ul style="margin-top: 10px" class="filterBox filter" [class.show]="display" [appDraggable]="true">
      <h3 class="dropdown-header m-0 filter-header show" style="margin: 0">
        <span class="grey darken-2">Filter</span>
        <button data-dismiss="filter" aria-label="Close" (click)="resetFilter()"
          class="notification-tag float-right m-0 close">
          ×
        </button>
      </h3>

      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label for="transaction_ref" class="col-sm-4 col-form-label">ID Number</label>
          <div class="col-sm-8">
            <input type="text" class="form-control round" name="transaction_ref" id="transaction_ref"
              [(ngModel)]="model.transaction_ref" />
          </div>
        </div>
      </li>
      @if (details?.permission === 'super_admin') {
        <li class="dropdown-header m-0">
          <div class="form-group row">
            <label for="transaction_ref" class="col-sm-4 col-form-label">Agent</label>
            <div class="col-sm-8">
              <select class="form-control round" name="agent" id="agent" [(ngModel)]="model.agent">
                @for (agent of agents; track agent) {
                  <option [value]="agent.id">
                    {{ agent.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        </li>
      }
      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label for="typeahead-http" class="col-sm-4 col-form-label">Bank</label>
          <div class="col-sm-8">
            <input id="typeahead-http" type="text" class="form-control round" name="bank"
              [class.is-invalid]="searchFailed" [(ngModel)]="model.bank" [ngbTypeahead]="search"
              placeholder="Search with Bank" />
            @if (searching) {
              <span>searching...</span>
            }
            @if (searchFailed) {
              <div class="invalid-feedback">
                Sorry, suggestions could not be loaded.
              </div>
            }
          </div>
        </div>
        <!--<pre>Model: {{ model.bank | json }}</pre>-->
      </li>

      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label for="sender" class="col-sm-4 col-form-label">Sender/Beneficiary</label>
          <div class="col-sm-8">
            <input type="text" class="form-control round" id="sender" name="name" [(ngModel)]="model.name" />
          </div>
        </div>
      </li>

      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label for="start_date" class="col-sm-4 col-form-label">Start Date</label>
          <div class="col-sm-8">
            <div class="input-group btn-round">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-calendar-o"></i>
                </span>
              </div>
              <input type="date" class="form-control pickadate btn-round" id="start_date" placeholder="Input Date"
                appDatePicker name="start_date" [(ngModel)]="model.start_date" />
            </div>
          </div>
        </div>
      </li>
      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label for="end_date" class="col-sm-4 col-form-label">End Date</label>
          <div class="col-sm-8">
            <div class="input-group btn-round">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-calendar-o"></i>
                </span>
              </div>
              <input type="date" class="form-control pickadate btn-round" id="end_date" placeholder="Input Date"
                appDatePicker name="end_date" [(ngModel)]="model.end_date" />
            </div>
          </div>
        </div>
      </li>
      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label" for="bank_transfer">Payment Method</label>
          <div class="col-sm-8">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" name="mode_of_payment"
                [(ngModel)]="model.mode_of_payment" id="bank_transfer" value="bank_transfer" />
              <label class="custom-control-label" for="bank_transfer">Bank Transfer</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" name="mode_of_payment"
                [(ngModel)]="model.mode_of_payment" id="cash" value="cash" />
              <label class="custom-control-label" for="cash">Cash</label>
            </div>
          </div>
        </div>
      </li>
      <li class="dropdown-header m-0">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label" for="new">Status</label>
          <div class="col-sm-8">
            <div class="custom-control custom-radio custom-control-inline new">
              <input type="radio" class="custom-control-input" name="status" id="new" [(ngModel)]="model.status"
                value="new" />
              <label class="custom-control-label" for="new">New</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline processing">
              <input type="radio" class="custom-control-input" name="status" id="processing" [(ngModel)]="model.status"
                value="processing" />
              <label class="custom-control-label" for="processing">processing</label>
            </div>
            <br />
            <div class="custom-control custom-radio custom-control-inline success">
              <input type="radio" class="custom-control-input" name="status" id="success" [(ngModel)]="model.status"
                value="success" />
              <label class="custom-control-label" for="success">success</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline failed">
              <input type="radio" class="custom-control-input" name="status" id="failed" [(ngModel)]="model.status"
                value="failed" />
              <label class="custom-control-label" for="failed">failed</label>
            </div>
          </div>
        </div>
      </li>
      <li class="dropdown-header m-0">
        <div class="form-group row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8 pull-right">
            <button type="submit" class="btn btn-success btn-round pl-30 pr-30 pull-right">
              Filter
            </button>
            <button (click)="resetFilter()" class="btn reset pl-30 pr-30 pull-right">
              Reset
            </button>
          </div>
        </div>
      </li>
    </ul>
  </form>
</div>